<template>
    <div style="text-align:center;">
        <IconFont type="icon-icon-404" style="font-size:300px;"/>
        <!-- <img :src="logo" alt=""> -->
        <Logo />
    </div>
</template>

<script>
import Logo from "@/assets/404.svg";
export default {
    components: {Logo, }
}
</script>

<style>

</style>